import styled from 'styled-components';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { HeartRateMeasurementEntry } from '../VitalSignsSection/HeartRateMeasurementEntry';
import { TemperatureMeasurementEntry } from '../VitalSignsSection/TemperatureMeasurementEntry';
import { BloodPressureMeasurementEntry } from '../VitalSignsSection/BloodPressureMeasurementEntry';
import { BloodSaturationMeasurementEntry } from '../VitalSignsSection/BloodSaturationMeasurementEntry';
import { ExaminationPageSection } from '../ExaminationPageSection';
import { IsPhysicalExaminationCompletedFn } from '@higo/common/src/features/ExaminationPage/models';
import { PhysicalExaminationType } from '@higo/api';
import { media } from '@higo/ui';

const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media.mobile.max} {
    flex-direction: row;
  }
`;

const StyledExaminationPageSection = styled(ExaminationPageSection)`
  display: grid;
  grid-template-rows: min-content minmax(0, 1fr);
`;

interface VitalSignsSectionProps {
  examinationId: number;
  physicalExaminationId?: number;
  isPhysicalExaminationCompletedFn: IsPhysicalExaminationCompletedFn;
}

export const VitalSignsSection: FC<VitalSignsSectionProps> = ({
  examinationId,
  physicalExaminationId,
  isPhysicalExaminationCompletedFn,
}) => {
  const measurementsExaminationId = physicalExaminationId ?? examinationId;

  return (
    <StyledExaminationPageSection
      title={<FormattedMessage id="examinationPage.section.lifeSigns.title" />}
      divider={null}
    >
      <Content>
        <TemperatureMeasurementEntry
          isAvailable={isPhysicalExaminationCompletedFn(
            PhysicalExaminationType.Temperature,
          )}
          examinationId={examinationId}
        />
        <HeartRateMeasurementEntry
          isAvailable={
            isPhysicalExaminationCompletedFn(PhysicalExaminationType.HeartRate) ||
            isPhysicalExaminationCompletedFn(PhysicalExaminationType.HeartRateWav)
          }
          examinationId={examinationId}
        />
        <BloodPressureMeasurementEntry
          isAvailable={true}
          examinationId={measurementsExaminationId}
        />
        <BloodSaturationMeasurementEntry
          isAvailable={true}
          examinationId={measurementsExaminationId}
        />
      </Content>
    </StyledExaminationPageSection>
  );
};
